const INITIAL_STATE = {
  data: {},
  errors: {},
};

const AddNewService = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case "CREATE_NEW_SERVICE_SUCCESSFULLY":
    return { ...INITIAL_STATE, data: action.data };
  case "CREATE_NEW_SERVICE_FAILED":
    return { ...INITIAL_STATE, errors: action.data };
  default:
    return { ...state };
  }
};
  
export default AddNewService;
      